import React from 'react';
import { Select, SelectProps } from '@material-ui/core';
import styled from 'styled-components';
import isClientside from '../../../utils/isClientside';

const StyledSelect = styled(Select)`
  min-height: 45px;
  &:focus {
    background-color: black;
  }

  .MuiSelect-root :focus {
    background-color: transparent;
  }

  .MuiSelect-root {
    padding-left: 18px !important;
    padding-right: 18px !important;
  }
`;

const SelectInput = ({ children, ...props }: Partial<SelectProps>) => {
  const bodyStyle = isClientside && document?.querySelector('body')?.style;

  return (
    <StyledSelect
      // (VIR-1158 start) temporary workaround solution for body overflow hidden issue
      MenuProps={{ disableScrollLock: true }}
      onOpen={() => {
        if (bodyStyle) {
          bodyStyle.overflow = 'hidden';
        }
      }}
      onClose={() => {
        if (bodyStyle) {
          bodyStyle.overflow = 'auto';
        }
      }}
      // (VIR-1158 end)
      {...props}
    >
      {children}
    </StyledSelect>
  );
};

export default SelectInput;
